// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-gif-container {
  position: fixed;
  margin: auto;
  top: 50%;
  left: 50%;
  z-index: 9;
  background: #ccc;
  height: 100%;
  width: 100%;
  opacity: 0.3;
  transform: translate(-50%, -50%);
}
.loading-gif-container img.loading-gif-icon {
  transform: translate(-50%, -50%);
  position: fixed;
  top: 50%;
  left: 50%;
}
.loading-gif-container div.loading-message {
  margin-top: -30px;
  text-align: center;
  padding: 5px;
  white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/common/components/LoadingComponent.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AACF;AAAE;EACE,gCAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AAEJ;AAAE;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AAEJ","sourcesContent":[".loading-gif-container {\n  position: fixed;\n  margin: auto;\n  top: 50%;\n  left: 50%;\n  z-index: 9;\n  background: #ccc;\n  height: 100%;\n  width: 100%;\n  opacity: 0.3;\n  transform: translate(-50%, -50%);\n  img.loading-gif-icon {\n    transform: translate(-50%, -50%);\n    position: fixed;\n    top: 50%;\n    left: 50%;\n  }\n  div.loading-message {\n    margin-top: -30px;\n    text-align: center;\n    padding: 5px;\n    white-space: pre-line;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
